module.exports = __webpack_public_path__ + "img/box.f0ae0025.svg";